import { render, staticRenderFns } from "./BomsItemListPage.vue?vue&type=template&id=311188ac&"
import script from "./BomsItemListPage.vue?vue&type=script&lang=ts&"
export * from "./BomsItemListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports